
// src/pages/forms/ABCpdfGenerators.js

import { PDFDocument } from 'pdf-lib';
import { PDFName,PDFCheckBox } from 'pdf-lib';
import { rgb, StandardFonts } from 'pdf-lib';
import {
  amendmentServiceDescription,
  amendmentServiceRecipients,
  appendAmendmentServiceList,
} from '../../utils/creditorMailingMatrix';
// Helper to log form field names
const API_URL2 = process.env.REACT_APP_BACKEND_URL;
const token = localStorage.getItem("accessToken");
async function generateCreditorsListPdf(creditors) {
    // Create the document
    const listDoc = await PDFDocument.create();
    creditors = Array.isArray(creditors) ? creditors : [];
    
    // Deduplicate by name & address
    const seen = new Set();
    creditors = creditors.filter(c => {
      const key = [c.name, c.street1, c.street2 || '', c.city, c.state, c.zip_code]
        .join('|');
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  
    const helvetica = await listDoc.embedFont(StandardFonts.Helvetica);
    const pageSize = [612, 792]; // Letter size
    let page = listDoc.addPage(pageSize);
    const { width, height } = page.getSize();
    const margin = 50;
    let y = height - margin;
    const lineHeight = 12;
    const indent = margin + 10;

    if (creditors.length === 0) {
      const message = 'No additional creditors were served.';
      const fontSize = 11;
      const textWidth = helvetica.widthOfTextAtSize(message, fontSize);
      page.drawText(message, {
        x: (width - textWidth) / 2,
        y: height - 100,
        size: fontSize,
        font: helvetica,
      });
      return listDoc;
    }
  
    for (const c of creditors) {
      // Name
      page.drawText(c.name, { x: margin, y, size: 10, font: helvetica });
      y -= lineHeight;
      // Address line 1
      page.drawText(
        `${c.street1}${c.street2?.trim() ? ', ' + c.street2 : ''}`,
        { x: indent, y, size: 10, font: helvetica }
      );
      y -= lineHeight;
      // City, State Zip
      page.drawText(
        `${c.city}, ${c.state} ${c.zip_code}`,
        { x: indent, y, size: 10, font: helvetica }
      );
      y -= lineHeight;
      // Method
      page.drawText(`Served via: ${c.method}`, { x: indent, y, size: 10, font: helvetica });
      y -= lineHeight * 1.5;
  
      if (y < margin) {
        page = listDoc.addPage(pageSize);
        y = height - margin;
      }
    }
  
    return listDoc;
  }

  async function generateEnvelopesPdf(creditors) {
    if (!creditors || creditors.length === 0) return;
    const envDoc = await PDFDocument.create();
    const seen = new Set();
    creditors = creditors.filter(c => {
      const key = [c.name, c.street1, c.street2 || '', c.city, c.state, c.zip_code]
        .join('|');
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
    // 1. Load & embed your logo (adjust the path as needed)
    const logoUrl = '/images/logo.png';
    const logoBytes = await fetch(logoUrl).then(r => r.arrayBuffer());
    const logoImage = await envDoc.embedPng(logoBytes);
    const logoDims = logoImage.scale(0.1);
  
    // 2. Prepare font and layout constants
    const font = await envDoc.embedFont(StandardFonts.Helvetica);
    const fontSize = 10;
    const lineHeight = fontSize + 4;
    const envelopeSize = [9.5 * 72, 4.125 * 72]; // width × height in points
    const margin = 25;
  
    // Your return address lines
    const returnAddress = [
      'Cisowski Law',
      '3119 Bristol Hwy Ste 217',
      'Johnson City, TN 37601',
    ];
  
    // 3. One page per creditor
    for (const c of creditors) {
      const page = envDoc.addPage(envelopeSize);
      const { width, height } = page.getSize();
  
      // 3a. Draw logo in top-left
      page.drawImage(logoImage, {
        x: margin,
        y: height - margin - logoDims.height,
        width: logoDims.width,
        height: logoDims.height,
      });
  
      // 3b. Draw return address to the right of the logo
      let yPos = height - margin - 9;
      for (const line of returnAddress) {
        page.drawText(line, {
          x: margin + logoDims.width + 10,
          y: yPos,
          size: fontSize,
          font,
        });
        yPos -= fontSize + 2;
      }
  
      // draw recipient address centered vertically and horizontally
      const addrLines = [
        c.name,
        `${c.street1}${c.street2?.trim() ? `, ${c.street2}` : ''}`,
        `${c.city}, ${c.state} ${c.zip_code}`,
      ];
      // measure max line width
      const lineWidths = addrLines.map(line => font.widthOfTextAtSize(line, fontSize));
      const maxWidth = Math.max(...lineWidths);
      const startX = (width - maxWidth) / 2;
      let startY = height / 2 + (addrLines.length / 2) * lineHeight;
      for (const line of addrLines) {
        page.drawText(line, {
          x: startX,
          y: startY,
          size: fontSize,
          font,
        });
        startY -= lineHeight;
      }
    }
  
    // 4. Save & trigger download
    const pdfBytes = await envDoc.save();
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'envelopes.pdf';
    link.click();
  }
function logFieldNames(form, label) {
  console.log(`--- ${label} Fields ---`);
  form.getFields().forEach(field => {
    console.log(field.getName());
  });
}
  // --- Helpers for new logic ---
  const setField = (name, value, form) => {
    try {
      const field = form.getTextField(name);
      if (field) field.setText(value || '');
    } catch {}
  };
  const setCheck = (name, checked = true, form) => {
    try {
      const cb = form.getCheckBox(name);
      if (cb) checked ? cb.check() : cb.uncheck();
    } catch {}
  };
  const sumAmounts = (items) =>
    items?.reduce((acc, item) => acc + (parseFloat(item.amount) || 0), 0).toFixed(2) || '0.00';
  const formatAmount = (amount) => {
    const n = parseFloat(amount);
    return isNaN(n) ? '' : n.toFixed(2);
  };
const fmtDate = (s) => {
      if (!s) return '';
      const [year, month, day] = s.split('-');
      return `${month}/${day}/${year}`;
    };
    // helper to format dates as a long string, e.g. "Thursday, May 29, 2025"
    const fmtLongDate = (s) => {
      if (!s) return '';
      const [year, month, day] = s.split('-').map(Number);
      // Construct date in local timezone to avoid UTC offset issues
      const d = new Date(year, month - 1, day);
      return d.toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    };
/**
 * Generate AB-7 PDF for household goods and personal property.
 * @param {Object} caseData - Case metadata (should include debtorName, caseNumber, householdGoods).
 * @param {Uint8Array} ab7Bytes - AB-7 template PDF bytes.
 * @returns {Promise<PDFDocument>}
 */
export async function generateAB7(caseData, ab7Bytes) {
  const pdfDoc = await PDFDocument.load(ab7Bytes);
  const form = pdfDoc.getForm();

  // Debtor 1 and case_number fields
  // Try various fields for debtor name and case number
  let debtorName = '';
  if (caseData.debtorName) debtorName = caseData.debtorName;
  else if (caseData.debtors && Array.isArray(caseData.debtors)) {
    const d1 = caseData.debtors.find(d => d.is_primary && d.is_filing);
    if (d1) debtorName = [d1.first_name, d1.second_name, d1.last_name].filter(Boolean).join(' ');
  }
  form.getTextField("Debtor 1").setText(debtorName || "");
  const caseNumber = caseData.caseNumber || caseData.case_number || "";
  form.getTextField("case_number").setText(caseNumber);

  // Items: householdGoods or householdItems
  const items = caseData.householdGoods || caseData.householdItems || [];
  // Categories as defined in AB-7
  const categories = [
    "furnishings", "electronics", "collectibles", "sports", "firearms",
    "clothes", "jewelry", "non_farm_animals", "other"
  ];

  let total = 0;
  for (const cat of categories) {
    const catItems = items.filter(i => i.category === cat);
    const hasItems = catItems.length > 0;
    // Checkbox fields
    if (hasItems) {
      form.getCheckBox(`${cat}_yes`).check();
      form.getCheckBox(`${cat}_no`).uncheck?.();
    } else {
      form.getCheckBox(`${cat}_no`).check();
      form.getCheckBox(`${cat}_yes`).uncheck?.();
    }
    // Description and amount
    if (hasItems) {
      const desc = catItems.map(i => `${i.description} ($${parseFloat(i.value).toFixed(2)})`).join("; ");
      const val = catItems.reduce((sum, i) => sum + (parseFloat(i.value) || 0), 0);
      form.getTextField(`${cat}_description`).setText(desc);
      form.getTextField(`${cat}_amount`).setText(val.toFixed(2));
      total += val;
    } else {
      // Clear description and amount if no items
      try { form.getTextField(`${cat}_description`).setText(""); } catch {}
      try { form.getTextField(`${cat}_amount`).setText(""); } catch {}
    }
  }
  form.getTextField("total_amount").setText(total.toFixed(2));
  // page_count and page_total left for now
  moveUncheckedCheckboxesToCorner(form, pdfDoc.getPages()[0].getSize(), pdfDoc.context);
  form.flatten();
  return pdfDoc;
}

function moveUncheckedCheckboxesToCorner(form, pageSize, context) {
  const { width, height } = pageSize;
  form.getFields().forEach(field => {
    // Only target PDFCheckBox fields
    if (field instanceof PDFCheckBox) {
      try {
        if (!field.isChecked()) {
          const widgets = field.acroField.getWidgets();
          widgets.forEach(widget => {
            const dict = widget.acroAnnotation?.dict || widget.dict;
            dict.set(
              PDFName.of('Rect'),
              context.obj([
                width + 5,
                height + 5,
                width + 15,
                height + 15
              ])
            );
          });
        }
      } catch {
        // ignore any errors moving individual checkboxes
      }
    }
  });
}
// Helper to sum vehicle values (parseFloat per vehicle, skip invalid)
export function calculateTotalVehicleValue(vehicleList) {
  if (!Array.isArray(vehicleList)) return 0;
  return vehicleList.reduce((sum, v) => {
    const val = parseFloat(v.value_total || v.valueTotal);
    return sum + (isNaN(val) ? 0 : val);
  }, 0);
}
// Generate AB-5 PDF for recreational vehicles
/**
 * @param {object} data - All case/vehicle data. Expects .debtor1.fullName, .caseNumber, .recreationalVehicles[]
 * @param {number} vehicleTotal - The total value of ALL vehicles (non-recreational and recreational)
 * @returns {Promise<PDFDocument>}
 */
export async function generateAB5(data, vehicleTotal, ab5Bytes) {
  const ab5Doc = await PDFDocument.load(ab5Bytes);
  const form = ab5Doc.getForm();

  // Fill Debtor 1 and Case Number
  if (data.debtor1 && data.debtor1.fullName) {
    form.getTextField('Debtor 1').setText(data.debtor1.fullName);
  }
  if (data.caseNumber) {
    form.getTextField('case_number').setText(data.caseNumber);
  }

  // Recreational vehicles: yes/no checkbox
  if (Array.isArray(data.recreationalVehicles) && data.recreationalVehicles.length === 0) {
    form.getCheckBox('recreation_no').check();
  } else {
    form.getCheckBox('recreation_yes').check();
  }

  // Loop through up to 4 recreational vehicles
  const recs = Array.isArray(data.recreationalVehicles) ? data.recreationalVehicles : [];
  for (let i = 0; i < 4; ++i) {
    const vehicle = recs[i];
    const idx = i + 1;
    if (!vehicle) continue;
    form.getTextField(`recreation_year_${idx}`).setText(vehicle.year?.toString() || '');
    form.getTextField(`recreation_make_${idx}`).setText(vehicle.make || '');
    form.getTextField(`recreation_model_${idx}`).setText(vehicle.model || '');
    form.getTextField(`recreation_other_information_${idx}`).setText(vehicle.other_info || '');
    form.getTextField(`recreation_value_total_${idx}`).setText(vehicle.value_total?.toString() || '');
    form.getTextField(`recreation_value_ownership_${idx}`).setText(vehicle.value_ownership_portion?.toString() || '');
    // Debtor checkboxes
    if (vehicle.ownership === 'debtor1') {
      form.getCheckBox(`recreation_debtor1_owes_${idx}`).check();
    } else if (vehicle.ownership === 'debtor2') {
      form.getCheckBox(`recreation_debtor2_owes_${idx}`).check();
    } else if (vehicle.ownership === 'd1_d2') {
      form.getCheckBox(`recreation_joint_owes_${idx}`).check();
    } else if (vehicle.ownership === 'joint_third') {
      form.getCheckBox(`recreation_third_owes_${idx}`).check();
    }
    // Community property
    if (vehicle.community_property) {
      form.getCheckBox(`recreation_community_${idx}`).check();
    }
  }

  // Fill vehicle_all_total
  form.getTextField('vehicle_all_total').setText(vehicleTotal != null ? String(vehicleTotal) : '');

  // Move unchecked checkboxes to corner
  moveUncheckedCheckboxesToCorner(form, ab5Doc.getPages()[0].getSize(), ab5Doc.context);
  form.flatten();
  return ab5Doc;
}

function fillRealPropertyFields(form, property, index,ab2,count) {
  const suffix = index + 1;
    const numberField = `real_estate_${index + 1}`;
  if (ab2){
    const realPropertyNumber = `1.${count + 1}`;
    form.getTextField(numberField).setText(realPropertyNumber);
  }
  form.getTextField(`street_${suffix}`).setText(property.street1 || '');
  form.getTextField(`street2_${suffix}`).setText(property.street2 || '');
  form.getTextField(`city_${suffix}`).setText(property.city || '');
  form.getTextField(`state_${suffix}`).setText(property.state || '');
  form.getTextField(`zip_${suffix}`).setText(property.zip_code || '');
  form.getTextField(`county_${suffix}`).setText(property.county || '');

  form.getTextField(`value_total_${suffix}`).setText(property.value_total ? String(property.value_total) : '');
  form.getTextField(`value_ownership_${suffix}`).setText(property.value_ownership_portion ? String(property.value_ownership_portion) : '');
  form.getTextField(`ownership_type_${suffix}`).setText(
    property.ownership_type
      ? property.ownership_type.split('_').map(word => word[0].toUpperCase() + word.slice(1)).join(' ')
      : ''
  );
  form.getTextField(`pin_${suffix}`).setText(property.other_info || '');
  
  if (property.ownership === 'debtor1') form.getCheckBox(`debtor1_owes_${suffix}`).check();
  else if (property.ownership === 'debtor2') form.getCheckBox(`debtor2_owes_${suffix}`).check();
  else if (property.ownership === 'd1_d2') form.getCheckBox(`joint_${suffix}`).check();
  else if (property.ownership === 'joint_third') form.getCheckBox(`third_${suffix}`).check();

  if (property.community_property) form.getCheckBox(`community_${suffix}`).check();

  const typeField = `${property.property_type}_${suffix}`;
  if (['single_family', 'duplex', 'condo', 'manufactured', 'land', 'investment', 'timeshare', 'other'].includes(property.property_type)) {
    try {
      form.getCheckBox(typeField).check();
    } catch {}
  }

  if (property.pin) {
    form.getTextField(`pin_${suffix}`).setText(property.pin);
  }
}

// Helper to fill vehicle fields on form
function fillVehicleFields(form, vehicles, offset, ab4) {
  vehicles.forEach((vehicle, i) => {
    const fieldIndex = i + 1;
    const fieldPrefix = `vehicle_`;

    // Numbering field (e.g., vehicle_1 = "3.3" for first vehicle on AB-4)
    if (ab4) {
      const vehicleNumberField = `${fieldPrefix}${fieldIndex}`;

        const vehicleNumber = `3.${offset + i + 3}`; // starts at 3.3
        form.getTextField(vehicleNumberField).setText(vehicleNumber);
      
    }

    form.getTextField(`${fieldPrefix}year_${fieldIndex}`).setText(vehicle.year?.toString() || '');
    form.getTextField(`${fieldPrefix}make_${fieldIndex}`).setText(vehicle.make || '');
    form.getTextField(`${fieldPrefix}model_${fieldIndex}`).setText(vehicle.model || '');
    form.getTextField(`${fieldPrefix}miles_${fieldIndex}`).setText(vehicle.mileage?.toString() || '');
    form.getTextField(`${fieldPrefix}value_total_${fieldIndex}`).setText(vehicle.value_total?.toString() || '');
    form.getTextField(`${fieldPrefix}value_ownership_${fieldIndex}`).setText(vehicle.value_ownership_portion?.toString() || '');
    form.getTextField(`${fieldPrefix}other_information_${fieldIndex}`).setText(vehicle.other_info || '');

    // Debtor checkboxes
    const ownership = vehicle.ownership;
    if (ownership === 'debtor1') {
      form.getCheckBox(`${fieldPrefix}debtor1_owes_${fieldIndex}`).check();
    } else if (ownership === 'debtor2') {
      form.getCheckBox(`${fieldPrefix}debtor2_owes_${fieldIndex}`).check();
    } else if (ownership === 'd1_d2') {
      form.getCheckBox(`${fieldPrefix}joint_owes_${fieldIndex}`).check();
    } else if (ownership === 'joint_third') {
      form.getCheckBox(`${fieldPrefix}third_owes_${fieldIndex}`).check();
    }

    // Community property checkbox
    if (vehicle.community_property) {
      form.getCheckBox(`${fieldPrefix}community_${fieldIndex}`).check();
    }
  });

}
async function generateAB8(realProperties, vehicles, householdGoods, financialAssets, businessAssets, farmAssets, otherProperties, ab8Bytes, caseData) {

  const ab8Doc = await PDFDocument.load(ab8Bytes);
  const ab8Form = ab8Doc.getForm();
  logFieldNames(ab8Form, "AB8")
  const caseDebtors = Array.isArray(caseData.debtors) ? caseData.debtors : [];
  const primaryDebtor = caseDebtors.find(d => d.is_primary && d.is_filing);
  if (primaryDebtor) {
    ab8Form.getTextField('Debtor 1').setText(
      [primaryDebtor.first_name, primaryDebtor.second_name, primaryDebtor.last_name]
        .filter(Boolean).join(' ')
    );
  }
  const realEstateTotal = realProperties.reduce((sum, p) => sum + (parseFloat(p.value_ownership_portion) || 0), 0);
  ab8Form.getTextField('total_real_estate_amount').setText(realEstateTotal.toFixed(2));

  const vehicleTotal = vehicles.reduce((sum, p) => sum + (parseFloat(p.value_ownership_portion) || 0), 0);
  ab8Form.getTextField('total_vehicles_amount').setText(vehicleTotal.toFixed(2));

    const householdTotal = householdGoods.reduce((sum, p) => sum + (parseFloat(p.value) || 0), 0);
  ab8Form.getTextField('total_household_amount').setText(householdTotal.toFixed(2));
  // --- Handle "cash" section based on financialAssets.cash array ---
  const cashAssets = financialAssets && Array.isArray(financialAssets.cash) ? financialAssets.cash : [];
  const totalCashAmount = cashAssets.reduce((sum, item) => sum + (item.amount || 0), 0);

  if (totalCashAmount > 0) {
    ab8Form.getCheckBox('cash_yes').check();
    ab8Form.getTextField('cash_amount').setText(totalCashAmount.toFixed(2));
  } else {
    ab8Form.getCheckBox('cash_no').check();
  }

  // --- Handle "deposits" section ---
  const deposits = financialAssets?.deposits || [];
  if (deposits.length) {
    ab8Form.getCheckBox("deposits_yes").check();
    ab8Form.getCheckBox("deposits_no").uncheck();

    const visibleDeposits = deposits.slice(0, 8);
    visibleDeposits.forEach((deposit, index) => {
      ab8Form.getTextField(`deposits_account_type_${index + 1}`).setText(deposit.account_type || "");
      ab8Form.getTextField(`deposits_institution_name_${index + 1}`).setText(deposit.institution_name || "");
      ab8Form.getTextField(`deposits_amount_${index + 1}`).setText((deposit.amount || 0).toString());
    });

    if (deposits.length > 9) {
      const extra = deposits.slice(8);
      const combinedNames = extra.map(d => `${d.institution_name} ($${d.amount})`).join("; ");
      const combinedTotal = extra.reduce((sum, d) => sum + (d.amount || 0), 0);

      ab8Form.getTextField("deposits_account_type_9").setText("additional");
      ab8Form.getTextField("deposits_institution_name_9").setText(combinedNames);
      ab8Form.getTextField("deposits_amount_9").setText(combinedTotal.toString());
    } else if (deposits.length === 9) {
      const d = deposits[8];
      ab8Form.getTextField("deposits_account_type_9").setText(d.account_type || "");
      ab8Form.getTextField("deposits_institution_name_9").setText(d.institution_name || "");
      ab8Form.getTextField("deposits_amount_9").setText((d.amount || 0).toString());
    }
  } else {
    ab8Form.getCheckBox("deposits_yes").uncheck();
    ab8Form.getCheckBox("deposits_no").check();
  }

  // --- Handle "brokerage accounts" section ---
  const brokerageAccounts = financialAssets?.brokerage_accounts || [];
  if (brokerageAccounts.length === 0) {
    ab8Form.getCheckBox('brokerage_accounts_no').check();
  } else {
    ab8Form.getCheckBox('brokerage_accounts_yes').check();
    brokerageAccounts.slice(0, 2).forEach((account, index) => {
      ab8Form.getTextField(`brokerage_accounts_institution_name_${index + 1}`).setText(account.institution_name);
      ab8Form.getTextField(`brokerage_accounts_amount_${index + 1}`).setText(account.amount.toString());
    });

    if (brokerageAccounts.length > 2) {
      const extraAccounts = brokerageAccounts.slice(2);
      const combinedNames = extraAccounts.map(acc => `${acc.institution_name} ($${acc.amount})`).join(', ');
      const totalExtraAmount = extraAccounts.reduce((sum, acc) => sum + acc.amount, 0);
      ab8Form.getTextField('brokerage_accounts_institution_name_3').setText(combinedNames);
      ab8Form.getTextField('brokerage_accounts_amount_3').setText(totalExtraAmount.toString());
    } else if (brokerageAccounts[2]) {
      ab8Form.getTextField('brokerage_accounts_institution_name_3').setText(brokerageAccounts[2].institution_name);
      ab8Form.getTextField('brokerage_accounts_amount_3').setText(brokerageAccounts[2].amount.toString());
    }
  }

  // --- Handle "nonpublic stocks" section ---
  const nonpublicStocks = financialAssets.nonpublic_stocks || [];
  if (nonpublicStocks.length === 0) {
    ab8Form.getCheckBox("nonpublic_stocks_no").check();
  } else {
    ab8Form.getCheckBox("nonpublic_stocks_yes").check();
    const count = Math.min(nonpublicStocks.length, 3);
    let totalValue = 0;
    for (let i = 0; i < count; i++) {
      const stock = nonpublicStocks[i];
      ab8Form.getTextField(`nonpublic_stocks_entity_name_${i + 1}`).setText(`${stock.entity_name} ($${stock.amount})`);
      ab8Form.getTextField(`nonpublic_stocks_ownership_percentage_${i + 1}`).setText(`${stock.ownership_percentage}%`);
      ab8Form.getTextField(`nonpublic_stocks_amount_${i + 1}`).setText(`${stock.amount}`);
      totalValue += stock.amount;
    }
    if (nonpublicStocks.length > 3) {
      const extra = nonpublicStocks.slice(2);
      const names = extra.map(s => `${s.entity_name} ($${s.amount})`).join("; ");
      const percentages = extra.map(s => `${s.ownership_percentage}%`).join("; ");
      const extraTotal = extra.reduce((sum, s) => sum + s.amount, 0);
      ab8Form.getTextField("nonpublic_stocks_entity_name_3").setText(names);
      ab8Form.getTextField("nonpublic_stocks_ownership_percentage_3").setText(percentages);
      ab8Form.getTextField("nonpublic_stocks_amount_3").setText(`${extraTotal}`);
    }
  }

  // --- Handle "bonds" section ---
  const bonds = financialAssets.bonds || [];
  if (bonds.length > 0) {
    ab8Form.getCheckBox('bonds_yes').check();
    ab8Form.getCheckBox('bonds_no').uncheck();
    bonds.slice(0, 2).forEach((bond, index) => {
      ab8Form.getTextField(`bonds_issuer_${index + 1}`).setText(bond.issuer || '');
      ab8Form.getTextField(`bonds_amount_${index + 1}`).setText(bond.amount?.toString() || '');
    });

    if (bonds.length > 2) {
      ab8Form.getTextField('bonds_issuer_3').setText(
        bonds.slice(2).map(b => `${b.issuer} ($${b.amount})`).join('; ')
      );
      ab8Form.getTextField('bonds_amount_3').setText(
        bonds.slice(2).reduce((sum, b) => sum + (b.amount || 0), 0).toString()
      );
    } else if (bonds.length === 3) {
      ab8Form.getTextField('bonds_issuer_3').setText(bonds[2].issuer || '');
      ab8Form.getTextField('bonds_amount_3').setText(bonds[2].amount?.toString() || '');
    }
  } else {
    ab8Form.getCheckBox('bonds_yes').uncheck();
    ab8Form.getCheckBox('bonds_no').check();
  }

  // --- Handle "annuities" section ---
  // Populate annuities as per new instructions
  const annuities = financialAssets?.annuities || [];
  if (annuities.length > 0) {
    ab8Form.getCheckBox('annuities_yes').check();
    ab8Form.getCheckBox('annuities_no').uncheck();
    if (annuities.length <= 3) {
      annuities.forEach((annuity, index) => {
        ab8Form.getTextField(`annuities_issuer_${index + 1}`).setText(annuity.issuer);
        ab8Form.getTextField(`annuities_amount_${index + 1}`).setText(annuity.amount?.toString() || '');
      });
    } else {
      // First two annuities individually
      annuities.slice(0, 2).forEach((annuity, index) => {
        ab8Form.getTextField(`annuities_issuer_${index + 1}`).setText(annuity.issuer);
        ab8Form.getTextField(`annuities_amount_${index + 1}`).setText(annuity.amount?.toString() || '');
      });
      // Combine the rest into the third field
      const remainingAnnuities = annuities.slice(2);
      const combinedIssuers = remainingAnnuities.map(a => `${a.issuer} ($${a.amount})`).join('; ');
      const combinedAmount = remainingAnnuities.reduce((sum, a) => sum + (a.amount || 0), 0);
      ab8Form.getTextField('annuities_issuer_3').setText(combinedIssuers);
      ab8Form.getTextField('annuities_amount_3').setText(combinedAmount.toString());
    }
  } else {
    ab8Form.getCheckBox('annuities_yes').uncheck();
    ab8Form.getCheckBox('annuities_no').check();
  }

  // --- Handle "retirement accounts" section ---
  const retirementAccounts = financialAssets?.retirement_accounts || [];
  if (retirementAccounts.length === 0) {
    ab8Form.getCheckBox('retirement_accounts_no').check();
  } else {
    ab8Form.getCheckBox('retirement_accounts_yes').check();

    const maxRetirementAccounts = 7;
    let totalAmount = 0;

    for (let i = 0; i < Math.min(retirementAccounts.length, maxRetirementAccounts); i++) {
      const acct = retirementAccounts[i];
      totalAmount += acct.amount || 0;

      ab8Form.getTextField(`retirement_accounts_entity_${i + 1}`).setText(acct.entity || '');
      ab8Form.getTextField(`retirement_accounts_account_type_${i + 1}`).setText(acct.account_type || '');
      ab8Form.getTextField(`retirement_accounts_amount_${i + 1}`).setText((acct.amount || 0).toString());
    }

    if (retirementAccounts.length > maxRetirementAccounts) {
      const extraAccounts = retirementAccounts.slice(maxRetirementAccounts - 1);
      const entities = extraAccounts.map(a => `${a.entity} ($${a.amount})`).join('; ');
      const extraAmount = extraAccounts.reduce((sum, a) => sum + (a.amount || 0), 0);
      totalAmount += extraAmount;

      ab8Form.getTextField(`retirement_accounts_entity_7`).setText(entities);
      ab8Form.getTextField(`retirement_accounts_account_type_7`).setText('additional');
      ab8Form.getTextField(`retirement_accounts_amount_7`).setText((extraAmount).toString());
    }
  }

  // --- Handle "security deposits" section ---
  // Security Deposits
  const securityDeposits = financialAssets?.security_deposits || [];
  if (securityDeposits.length === 0) {
    ab8Form.getCheckBox('security_deposits_no')?.check?.();
    ab8Form.getCheckBox('security_deposits_yes')?.uncheck?.();
  } else {
    ab8Form.getCheckBox('security_deposits_yes')?.check?.();
    ab8Form.getCheckBox('security_deposits_no')?.uncheck?.();
    if (securityDeposits.length <= 9) {
      securityDeposits.forEach((deposit, index) => {
        const i = index + 1;
        ab8Form.getTextField(`security_deposits_deposit_type_${i}`)?.setText(deposit.deposit_type || '');
        ab8Form.getTextField(`security_deposits_institution_${i}`)?.setText(deposit.institution || '');
        ab8Form.getTextField(`security_deposits_amount_${i}`)?.setText(deposit.amount?.toString() || '');
      });
    } else {
      securityDeposits.slice(0, 8).forEach((deposit, index) => {
        const i = index + 1;
        ab8Form.getTextField(`security_deposits_deposit_type_${i}`)?.setText(deposit.deposit_type || '');
        ab8Form.getTextField(`security_deposits_institution_${i}`)?.setText(deposit.institution || '');
        ab8Form.getTextField(`security_deposits_amount_${i}`)?.setText(deposit.amount?.toString() || '');
      });
      const extra = securityDeposits.slice(8);
      ab8Form.getTextField(`security_deposits_deposit_type_9`)?.setText('additional');
      ab8Form.getTextField(`security_deposits_institution_9`)?.setText(extra.map(d => `${d.deposit_type}: ${d.institution} ($${d.amount})`).join('; '));
      ab8Form.getTextField(`security_deposits_amount_9`)?.setText(extra.reduce((sum, d) => sum + (d.amount || 0), 0).toString());
    }
  }

    // --- New: trusts ---
  // --- New: trusts ---
  const trusts = financialAssets?.trusts || [];
  if (!trusts.length) {
    ab8Form.getCheckBox('trusts_no').check();
    ab8Form.getCheckBox('trusts_yes').uncheck();
    ab8Form.getTextField('trusts_description').setText('');
    ab8Form.getTextField('trusts_amount').setText('');
  } else {
    ab8Form.getCheckBox('trusts_no').uncheck();
    ab8Form.getCheckBox('trusts_yes').check();
    ab8Form.getTextField('trusts_description').setText(trusts.map(t => `${t.description || ''} ($${t.amount || ''})`).join('; '));
    ab8Form.getTextField('trusts_amount').setText(sumAmounts(trusts));
  }

  // --- New: patents ---
  const patents = financialAssets?.patents || [];
  if (!patents.length) {
    ab8Form.getCheckBox('patents_no').check();
    ab8Form.getCheckBox('patents_yes').uncheck();
    ab8Form.getTextField('patents_issuer').setText('');
    ab8Form.getTextField('patents_amount').setText('');
  } else {
    ab8Form.getCheckBox('patents_no').uncheck();
    ab8Form.getCheckBox('patents_yes').check();
    ab8Form.getTextField('patents_issuer').setText(patents.map(p => `${p.issuer || ''} ($${p.amount || ''})`).join('; '));
    ab8Form.getTextField('patents_amount').setText(sumAmounts(patents));
  }

  // --- New: franchises ---
  const franchises = financialAssets?.franchises || [];
  if (!franchises.length) {
    ab8Form.getCheckBox('franchises_no').check();
    ab8Form.getCheckBox('franchises_yes').uncheck();
    ab8Form.getTextField('franchises_issuer').setText('');
    ab8Form.getTextField('franchises_amount').setText('');
  } else {
    ab8Form.getCheckBox('franchises_no').uncheck();
    ab8Form.getCheckBox('franchises_yes').check();
    ab8Form.getTextField('franchises_issuer').setText(franchises.map(f => `${f.issuer || ''} ($${f.amount || ''})`).join('; '));
    ab8Form.getTextField('franchises_amount').setText(sumAmounts(franchises));
  }

  // --- New: other_amounts_owed ---
  const otherAmountsOwed = financialAssets?.other_amounts_owed || [];
  if (!otherAmountsOwed.length) {
    ab8Form.getCheckBox('other_amounts_owed_no').check();
    ab8Form.getCheckBox('other_amounts_owed_yes').uncheck();
    ab8Form.getTextField('other_amounts_owed_description').setText('');
    ab8Form.getTextField('other_amounts_owed_amount').setText('');
  } else {
    ab8Form.getCheckBox('other_amounts_owed_no').uncheck();
    ab8Form.getCheckBox('other_amounts_owed_yes').check();
    ab8Form.getTextField('other_amounts_owed_description').setText(otherAmountsOwed.map(o => `${o.description || ''} ($${o.amount || ''})`).join('; '));
    ab8Form.getTextField('other_amounts_owed_amount').setText(sumAmounts(otherAmountsOwed));
  }

    // --- New: insurance_interests (up to 3) ---
  const educationIRAs = financialAssets?.education_iras || [];
  if (!educationIRAs.length) {
    ab8Form.getCheckBox('education_iras_no').check();
    ab8Form.getCheckBox('education_iras_yes').uncheck();
    for (let i = 1; i <= 3; ++i) {
      ab8Form.getTextField(`education_iras_issuer_${i}`).setText('');
      ab8Form.getTextField(`education_iras_amount_${i}`).setText('');
    }
  } else {
    ab8Form.getCheckBox('education_iras_no').uncheck();
    ab8Form.getCheckBox('education_iras_yes').check();
    if (educationIRAs.length <= 3) {
      educationIRAs.forEach((asset, i) => {
        ab8Form.getTextField(`education_iras_issuer_${i + 1}`).setText(asset.issuer || '');
        ab8Form.getTextField(`education_iras_amount_${i + 1}`).setText(formatAmount(asset.amount));
      });
      // Clear any unused fields
      for (let i = educationIRAs.length + 1; i <= 3; ++i) {
        ab8Form.getTextField(`education_iras_issuer_${i}`).setText('');
        ab8Form.getTextField(`education_iras_amount_${i}`).setText('');
      }
    } else {
      // More than 3: first two as normal, third as combined
      // First
      ab8Form.getTextField('education_iras_issuer_1').setText(educationIRAs[0].issuer || '');
      ab8Form.getTextField('education_iras_amount_1').setText(formatAmount(educationIRAs[0].amount));
      // Second
      ab8Form.getTextField('education_iras_issuer_2').setText(educationIRAs[1].issuer || '');
      ab8Form.getTextField('education_iras_amount_2').setText(formatAmount(educationIRAs[1].amount));
      // Third: combine all remaining
      const remaining = educationIRAs.slice(2);
      ab8Form.getTextField('education_iras_issuer_3').setText(
        remaining.map(item => `${item.issuer || ''} $${item.amount || ''} `).join('; ')
      );
      ab8Form.getTextField('education_iras_amount_3').setText(
        formatAmount(remaining.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0))
      );
    }
  }

  // --- New: insurance_interests (up to 3) ---
  const insuranceInterests = financialAssets?.insurance_interests || [];
  if (!insuranceInterests.length) {
    ab8Form.getCheckBox('insurance_interests_no').check();
    ab8Form.getCheckBox('insurance_interests_yes').uncheck();
    for (let i = 1; i <= 3; ++i) {
      ab8Form.getTextField(`insurance_interests_company_${i}`).setText('');
      ab8Form.getTextField(`insurance_interests_beneficiary_${i}`).setText('');
      ab8Form.getTextField(`insurance_interests_amount_${i}`).setText('');
    }
  } else {
    ab8Form.getCheckBox('insurance_interests_no').uncheck();
    ab8Form.getCheckBox('insurance_interests_yes').check();
    if (insuranceInterests.length <= 3) {
      insuranceInterests.forEach((asset, i) => {
        ab8Form.getTextField(`insurance_interests_company_${i + 1}`).setText(asset.company || '');
        ab8Form.getTextField(`insurance_interests_beneficiary_${i + 1}`).setText(asset.beneficiary || '');
        ab8Form.getTextField(`insurance_interests_amount_${i + 1}`).setText(formatAmount(asset.amount));
      });
      // Clear any unused fields
      for (let i = insuranceInterests.length + 1; i <= 3; ++i) {
        ab8Form.getTextField(`insurance_interests_company_${i}`).setText('');
        ab8Form.getTextField(`insurance_interests_beneficiary_${i}`).setText('');
        ab8Form.getTextField(`insurance_interests_amount_${i}`).setText('');
      }
    } else {
      // More than 3: first two as normal, third as combined
      // First
      ab8Form.getTextField('insurance_interests_company_1').setText(insuranceInterests[0].company || '');
      ab8Form.getTextField('insurance_interests_beneficiary_1').setText(insuranceInterests[0].beneficiary || '');
      ab8Form.getTextField('insurance_interests_amount_1').setText(formatAmount(insuranceInterests[0].amount));
      // Second
      ab8Form.getTextField('insurance_interests_company_2').setText(insuranceInterests[1].company || '');
      ab8Form.getTextField('insurance_interests_beneficiary_2').setText(insuranceInterests[1].beneficiary || '');
      ab8Form.getTextField('insurance_interests_amount_2').setText(formatAmount(insuranceInterests[1].amount));
      // Third: combine all remaining
      const remaining = insuranceInterests.slice(2);
      ab8Form.getTextField('insurance_interests_company_3').setText(
        remaining.map(item => `${item.company || ''} $${item.amount || ''} `).join('; ')
      );
      ab8Form.getTextField('insurance_interests_beneficiary_3').setText(
        remaining.map(item => item.beneficiary || '').join('; ')
      );
      ab8Form.getTextField('insurance_interests_amount_3').setText(
        formatAmount(remaining.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0))
      );
    }
  }

  // --- New: inheritance_interests ---
  const inheritanceInterests = financialAssets?.inheritance_interests || [];
  if (!inheritanceInterests.length) {
    ab8Form.getCheckBox('inheritance_interests_no').check();
    ab8Form.getCheckBox('inheritance_interests_yes').uncheck();
    ab8Form.getTextField('inheritance_interests_description').setText('');
    ab8Form.getTextField('inheritance_interests_amount').setText('');
  } else {
    ab8Form.getCheckBox('inheritance_interests_no').uncheck();
    ab8Form.getCheckBox('inheritance_interests_yes').check();
    ab8Form.getTextField('inheritance_interests_description').setText(inheritanceInterests.map(i => `${i.description || ''} ($${i.amount})`).join('; '));
    ab8Form.getTextField('inheritance_interests_amount').setText(sumAmounts(inheritanceInterests));
  }

  // --- New: lawsuit_interests ---
  const lawsuitInterests = financialAssets?.lawsuit_interests || [];
  if (!lawsuitInterests.length) {
    ab8Form.getCheckBox('lawsuit_interests_no').check();
    ab8Form.getCheckBox('lawsuit_interests_yes').uncheck();
    ab8Form.getTextField('lawsuit_interests_description').setText('');
    ab8Form.getTextField('lawsuit_interests_amount').setText('');
  } else {
    ab8Form.getCheckBox('lawsuit_interests_no').uncheck();
    ab8Form.getCheckBox('lawsuit_interests_yes').check();
    ab8Form.getTextField('lawsuit_interests_description').setText(lawsuitInterests.map(l => `${l.description || ''} ($${l.amount})`).join('; '));
    ab8Form.getTextField('lawsuit_interests_amount').setText(sumAmounts(lawsuitInterests));
  }

  // --- New: contingent_claims ---
  const contingentClaims = financialAssets?.contingent_claims || [];
  if (!contingentClaims.length) {
    ab8Form.getCheckBox('contingent_claims_no').check();
    ab8Form.getCheckBox('contingent_claims_yes').uncheck();
    ab8Form.getTextField('contingent_claims_description').setText('');
    ab8Form.getTextField('contingent_claims_amount').setText('');
  } else {
    ab8Form.getCheckBox('contingent_claims_no').uncheck();
    ab8Form.getCheckBox('contingent_claims_yes').check();
    ab8Form.getTextField('contingent_claims_description').setText(contingentClaims.map(c => `${c.description || ''} ($${c.amount})`).join('; '));
    ab8Form.getTextField('contingent_claims_amount').setText(sumAmounts(contingentClaims));
  }

  // --- New: other_financial_assets ---
  const otherFinancialAssets = financialAssets?.other_financial_assets || [];
  if (!otherFinancialAssets.length) {
    ab8Form.getCheckBox('other_financial_assets_no').check();
    ab8Form.getCheckBox('other_financial_assets_yes').uncheck();
    ab8Form.getTextField('other_financial_assets_description').setText('');
    ab8Form.getTextField('other_financial_assets_amount').setText('');
  } else {
    ab8Form.getCheckBox('other_financial_assets_no').uncheck();
    ab8Form.getCheckBox('other_financial_assets_yes').check();
    ab8Form.getTextField('other_financial_assets_description').setText(otherFinancialAssets.map(o => `${o.description || ''} ($${o.amount})`).join('; '));
    ab8Form.getTextField('other_financial_assets_amount').setText(sumAmounts(otherFinancialAssets));
  }
const obligations = financialAssets?.obligations || [];

if (obligations.length === 0) {
  ab8Form.getCheckBox('obligations_no')?.check?.();
  ab8Form.getCheckBox('obligations_yes')?.uncheck?.();
  ab8Form.getTextField('obligations_description')?.setText?.('');
  ab8Form.getTextField('obligations_maintenance_amount')?.setText?.('');
  ab8Form.getTextField('obligations_support_amount')?.setText?.('');
  ab8Form.getTextField('obligations_divorce_settlement_amount')?.setText?.('');
  ab8Form.getTextField('obligations_alimony_amount')?.setText?.('');
  ab8Form.getTextField('obligations_property_settlement_amount')?.setText?.('');
} else {
  ab8Form.getCheckBox('obligations_yes')?.check?.();
  ab8Form.getCheckBox('obligations_no')?.uncheck?.();

  const description = obligations.map(o => `${o.obligation_type}: ${o.description} $${o.amount}`).join('; ');

  const maintenanceTotal = obligations
    .filter(o => o.obligation_type === 'maintenance')
    .reduce((sum, o) => sum + (o.amount || 0), 0);
  const supportTotal = obligations
    .filter(o => o.obligation_type === 'support')
    .reduce((sum, o) => sum + (o.amount || 0), 0);
  const divorceTotal = obligations
    .filter(o => o.obligation_type === 'divorce_settlement')
    .reduce((sum, o) => sum + (o.amount || 0), 0);
  const alimonyTotal = obligations
    .filter(o => o.obligation_type === 'alimony')
    .reduce((sum, o) => sum + (o.amount || 0), 0);
  const propertyTotal = obligations
    .filter(o => o.obligation_type === 'property_settlement')
    .reduce((sum, o) => sum + (o.amount || 0), 0);

  ab8Form.getTextField('obligations_description')?.setText?.(description);
  ab8Form.getTextField('obligations_maintenance_amount')?.setText?.(maintenanceTotal.toFixed(2));
  ab8Form.getTextField('obligations_support_amount')?.setText?.(supportTotal.toFixed(2));
  ab8Form.getTextField('obligations_divorce_settlement_amount')?.setText?.(divorceTotal.toFixed(2));
  ab8Form.getTextField('obligations_alimony_amount')?.setText?.(alimonyTotal.toFixed(2));
  ab8Form.getTextField('obligations_property_settlement_amount')?.setText?.(propertyTotal.toFixed(2));
}
  // --- TAX REFUNDS ---
  // TAX REFUNDS
  const taxRefunds = financialAssets?.tax_refunds || [];

  if (taxRefunds.length === 0) {
    ab8Form.getCheckBox('tax_refunds_no')?.check?.();
    ab8Form.getCheckBox('tax_refunds_yes')?.uncheck?.();
    ab8Form.getTextField('tax_refunds_description')?.setText?.('');
    ab8Form.getTextField('tax_refunds_federal_amount')?.setText?.('');
    ab8Form.getTextField('tax_refunds_state_amount')?.setText?.('');
    ab8Form.getTextField('tax_refunds_local_amount')?.setText?.('');
  } else {
    ab8Form.getCheckBox('tax_refunds_yes')?.check?.();
    ab8Form.getCheckBox('tax_refunds_no')?.uncheck?.();

    const description = taxRefunds.map(refund => `${refund.description} $${refund.amount}}`).join('; ');
    const federalTotal = taxRefunds
      .filter(refund => refund.tax_type === 'federal')
      .reduce((sum, refund) => sum + (refund.amount || 0), 0);
    const stateTotal = taxRefunds
      .filter(refund => refund.tax_type === 'state')
      .reduce((sum, refund) => sum + (refund.amount || 0), 0);
    const localTotal = taxRefunds
      .filter(refund => refund.tax_type === 'local')
      .reduce((sum, refund) => sum + (refund.amount || 0), 0);

    ab8Form.getTextField('tax_refunds_description')?.setText?.(description);
    ab8Form.getTextField('tax_refunds_federal_amount')?.setText?.(federalTotal.toFixed(2));
    ab8Form.getTextField('tax_refunds_state_amount')?.setText?.(stateTotal.toFixed(2));
    ab8Form.getTextField('tax_refunds_local_amount')?.setText?.(localTotal.toFixed(2));
  }
const financialTotal =
  (financialAssets.cash || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.deposits || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.brokerage_accounts || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.nonpublic_stocks || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.retirement_accounts || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.security_deposits || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.annuities || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.education_iras || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.trusts || []).reduce((sum, item) => sum + (item.amount || 0), 0)+
  (financialAssets.patents || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.franchises || []).reduce((sum, item) => sum + (item.amount || 0), 0)+
  (financialAssets.tax_refunds || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.obligations || []).reduce((sum, item) => sum + (item.amount || 0), 0)+
  (financialAssets.other_amounts_owed || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.insurance_interests || []).reduce((sum, item) => sum + (item.amount || 0), 0)+
  (financialAssets.inheritance_interests || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.lawsuit_interests || []).reduce((sum, item) => sum + (item.amount || 0), 0)+
  (financialAssets.contingent_claims || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.other_financial_assets || []).reduce((sum, item) => sum + (item.amount || 0), 0);

  ab8Form.getTextField('total_financial_assets_amount')?.setText?.(financialTotal.toFixed(2));

  // BUSINESS ASSETS BELOW THIS LINE
  // Use new logic to populate business asset fields based on supplied field names
  const businessAssetsObj = businessAssets || {};

  // Check if any business assets exist
  const anyBusinessAssetsExist = Object.values(businessAssetsObj).some(list => Array.isArray(list) && list.length > 0);

  if (!anyBusinessAssetsExist) {
    ab8Form.getCheckBox('business_assets_no')?.check?.();
    ab8Form.getCheckBox('business_assets_yes')?.uncheck?.();
  } else {
    ab8Form.getCheckBox('business_assets_yes')?.check?.();
    ab8Form.getCheckBox('business_assets_no')?.uncheck?.();
  }

  function populateSimpleCategory(category, yesField, noField, descriptionField, amountField) {
    const items = businessAssetsObj[category] || [];
    if (items.length === 0) {
      ab8Form.getCheckBox(noField)?.check?.();
      ab8Form.getCheckBox(yesField)?.uncheck?.();
      ab8Form.getTextField(descriptionField)?.setText?.('');
      ab8Form.getTextField(amountField)?.setText?.('');
    } else {
      ab8Form.getCheckBox(yesField)?.check?.();
      ab8Form.getCheckBox(noField)?.uncheck?.();
      const description = items.map(item => item.description).join('; ');
      const amount = items.reduce((sum, item) => sum + (item.amount || 0), 0);
      ab8Form.getTextField(descriptionField)?.setText?.(description);
      ab8Form.getTextField(amountField)?.setText?.(amount.toFixed(2));
    }
  }

  // Handle simple one-box asset types
  populateSimpleCategory('accounts_receivable', 'accounts_receivable_yes', 'accounts_receivable_no', 'accounts_receivable_description', 'accounts_receivable_amount');
  populateSimpleCategory('office_equipments', 'office_equipments_yes', 'office_equipments_no', 'office_equipments_description', 'office_equipments_amount');
  populateSimpleCategory('machinery_equipments', 'machinery_equipments_yes', 'machinery_equipments_no', 'machinery_equipments_description', 'machinery_equipments_amount');
  populateSimpleCategory('inventories', 'inventories_yes', 'inventories_no', 'inventories_description', 'inventories_amount');
  populateSimpleCategory('customer_lists', 'customer_lists_yes', 'customer_lists_no', 'customer_lists_description', 'customer_lists_amount');

  // Partnership Interests
  const partnerships = businessAssetsObj.partnership_interests || [];
  if (partnerships.length === 0) {
  ab8Form.getCheckBox('partnership_interests_no')?.check?.();
  ab8Form.getCheckBox('partnership_interests_yes')?.uncheck?.();
} else {
  ab8Form.getCheckBox('partnership_interests_yes')?.check?.();
  ab8Form.getCheckBox('partnership_interests_no')?.uncheck?.();

  partnerships.slice(0, 2).forEach((item, idx) => {
    ab8Form.getTextField(`partnership_interests_description_${idx + 1}`)?.setText(`${item.description}`);
    ab8Form.getTextField(`partnership_interests_percent_ownership_${idx + 1}`)?.setText(`${item.percent_ownership}`);
    ab8Form.getTextField(`partnership_interests_amount_${idx + 1}`)?.setText(`${item.amount.toFixed(2)}`);
  });

  // Combine extras into field 3
  const overflow = partnerships.slice(2);
  const combinedDesc = overflow.map(p => `${p.description} (${p.percent_ownership}%) ($${p.amount})`).join('; ');
  const combinedAmount = overflow.reduce((sum, p) => sum + (p.amount || 0), 0);

  ab8Form.getTextField(`partnership_interests_description_3`)?.setText(combinedDesc);
  ab8Form.getTextField(`partnership_interests_percent_ownership_3`)?.setText('');
  ab8Form.getTextField(`partnership_interests_amount_3`)?.setText(combinedAmount ? combinedAmount.toFixed(2) : '');
}

  // Other Business Properties
  const otherBusinessProps = businessAssetsObj.other_business_properties || [];
if (otherBusinessProps.length === 0) {
  ab8Form.getCheckBox('other_business_properties_no')?.check?.();
  ab8Form.getCheckBox('other_business_properties_yes')?.uncheck?.();

  // Clear all fields
  for (let i = 1; i <= 6; i++) {
    ab8Form.getTextField(`other_business_properties_description_${i}`)?.setText('');
    ab8Form.getTextField(`other_business_properties_amount_${i}`)?.setText('');
  }
} else {
  ab8Form.getCheckBox('other_business_properties_yes')?.check?.();
  ab8Form.getCheckBox('other_business_properties_no')?.uncheck?.();

  const maxVisible = 5;
  const visibleItems = otherBusinessProps.slice(0, maxVisible);
  const overflowItems = otherBusinessProps.slice(maxVisible);

  // Populate the first 5 rows
  visibleItems.forEach((item, idx) => {
    ab8Form.getTextField(`other_business_properties_description_${idx + 1}`)?.setText(`${item.description || ''}`);
    ab8Form.getTextField(`other_business_properties_amount_${idx + 1}`)?.setText(item.amount?.toFixed(2) || '');
  });

  // Handle the 6th row (catch-all for extras)
  if (overflowItems.length > 0) {
    const overflowDesc = overflowItems.map(item => `${item.description || ''} ($${item.amount})`).join('; ');
    const overflowTotal = overflowItems.reduce((sum, item) => sum + (item.amount || 0), 0);

    ab8Form.getTextField('other_business_properties_description_6')?.setText(overflowDesc);
    ab8Form.getTextField('other_business_properties_amount_6')?.setText(overflowTotal.toFixed(2));
  } else {
    // Clear if nothing overflowed
    ab8Form.getTextField('other_business_properties_description_6')?.setText('');
    ab8Form.getTextField('other_business_properties_amount_6')?.setText('');
  }
}
const businessTotal =
  (businessAssets.accounts_receivable || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (businessAssets.office_equipments || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (businessAssets.machinery_equipments || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (businessAssets.inventories || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (businessAssets.partnership_interests || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (businessAssets.customer_lists || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (businessAssets.other_business_properties || []).reduce((sum, item) => sum + (item.amount || 0), 0);

ab8Form.getTextField('business_assets_total_amount')?.setText?.(businessTotal.toFixed(2));
// FARM PROPERTY BELOW THIS LINE

const farmTypes = [
  { key: 'farm_animals', pdfPrefix: 'farm_animals' },
  { key: 'crops', pdfPrefix: 'crops' },
  { key: 'farm_equipments', pdfPrefix: 'farm_equipments' },
  { key: 'supplies_feed', pdfPrefix: 'supplies_feed' },
  { key: 'other_farm_properties', pdfPrefix: 'other_farm_properties' },
];

// Check if any farm asset is present
const hasAnyFarmAsset = farmTypes.some(({ key }) => Array.isArray(farmAssets[key]) && farmAssets[key].length > 0);
if (hasAnyFarmAsset)
{
  ab8Form.getCheckBox('farm_assets_yes')?.check?.();
  ab8Form.getCheckBox('farm_assets_no')?.uncheck?.();
} else {
ab8Form.getCheckBox('farm_assets_yes')?.uncheck?.();
ab8Form.getCheckBox('farm_assets_no')?.check?.();
}
  
  
console.log(farmAssets)
console.log(farmTypes)
// Handle each farm property type
farmTypes.forEach(({ key, pdfPrefix }) => {
  const items = Array.isArray(farmAssets[key]) ? farmAssets[key] : [];
  const hasItems = items.length > 0;

    if (hasItems) {
      ab8Form.getCheckBox(`${pdfPrefix}_yes`)?.check?.();
      ab8Form.getCheckBox(`${pdfPrefix}_no`)?.uncheck?.();
    } else {
      ab8Form.getCheckBox(`${pdfPrefix}_yes`)?.uncheck?.();
      ab8Form.getCheckBox(`${pdfPrefix}_no`)?.check?.();
    }

  if (!hasItems) {
    ab8Form.getTextField(`${pdfPrefix}_description`)?.setText?.('');
    ab8Form.getTextField(`${pdfPrefix}_amount`)?.setText?.('');
  } else {
    const description = items.map(item => `${item.description}: $${item.amount?.toFixed(2) ?? '0.00'}`).join('; ');
    const total = items.reduce((sum, item) => sum + (item.amount || 0), 0);

    ab8Form.getTextField(`${pdfPrefix}_description`)?.setText?.(description);
    ab8Form.getTextField(`${pdfPrefix}_amount`)?.setText?.(total.toFixed(2));
  }
});
const farmTotal =
  (farmAssets.farm_animals || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (farmAssets.crops || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (farmAssets.farm_equipments || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (farmAssets.supplies_feed || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (farmAssets.other_farm_properties || []).reduce((sum, item) => sum + (item.amount || 0), 0);

ab8Form.getTextField('farm_assets_total_amount')?.setText?.(farmTotal.toFixed(2));
/// OTHER PROEPRTIES BELOW THIS LINE
console.log(otherProperties)
const otherPropertyItems = Array.isArray(otherProperties) ? otherProperties : [];

if (otherPropertyItems.length === 0) {
  ab8Form.getCheckBox('other_properties_no')?.check?.();
  ab8Form.getCheckBox('other_properties_yes')?.uncheck?.();
  ab8Form.getTextField('other_properties_description')?.setText?.('');
  ab8Form.getTextField('other_properties_amount')?.setText?.('');
} else {
  ab8Form.getCheckBox('other_properties_yes')?.check?.();
  ab8Form.getCheckBox('other_properties_no')?.uncheck?.();

  const desc = otherPropertyItems.map(item => `${item.description} ($${item.amount})`).join('; ');
  const total = otherPropertyItems.reduce((sum, item) => sum + (item.amount || 0), 0);

  ab8Form.getTextField('other_properties_description')?.setText?.(desc);
  ab8Form.getTextField('other_properties_amount')?.setText?.(total.toFixed(2));

}

//ADDING UP ALL PERSONAL PROPERTY
const personalPropertyTotal = vehicleTotal + householdTotal + financialTotal + businessTotal + farmTotal + otherPropertyItems.reduce((sum, item) => sum + (item.amount || 0), 0);
ab8Form.getTextField('total_personal_property_amount')?.setText?.(personalPropertyTotal.toFixed(2));

const propertyTotal = personalPropertyTotal + realEstateTotal
 ab8Form.getTextField('total_assets_amount')?.setText?.(propertyTotal.toFixed(2));
  // (Other AB-8 logic goes here...)
  moveUncheckedCheckboxesToCorner(ab8Form, ab8Doc.getPages()[0].getSize(), ab8Doc.context);
  ab8Form.flatten();
  return ab8Doc;
}
async function generateAB2(realProperties, ab2Bytes, caseData, startIndex) {
  const ab2Doc = await PDFDocument.load(ab2Bytes);
  const ab2Form = ab2Doc.getForm();
  logFieldNames(ab2Form, 'AB-2');

  const caseDebtors = Array.isArray(caseData.debtors) ? caseData.debtors : [];
  const primaryDebtor = caseDebtors.find(d => d.is_primary && d.is_filing);
  if (primaryDebtor) {
    ab2Form.getTextField('Debtor 1').setText(
      [primaryDebtor.first_name, primaryDebtor.second_name, primaryDebtor.last_name]
        .filter(Boolean).join(' ')
    );
  }
  ab2Form.getTextField('case_number').setText(caseData?.case_number || '');
  let count = 0
  for (let i = 0; i < 3; i++) {
    const prop = realProperties[startIndex + i];
    if (prop) fillRealPropertyFields(ab2Form, prop, i,true,startIndex + count);
    count++;
  }
  moveUncheckedCheckboxesToCorner(ab2Form, ab2Doc.getPages()[0].getSize(), ab2Doc.context);
  ab2Form.flatten();
  return ab2Doc;
}
async function generateAB1(ab1Bytes, caseData, realProperties,amended) {
  const ab1Doc = await PDFDocument.load(ab1Bytes);
  const ab1Form = ab1Doc.getForm();

  console.log(caseData)
  const caseDebtors = Array.isArray(caseData.debtors) ? caseData.debtors : [];
  const primaryDebtor = caseDebtors.find(d => d.is_primary && d.is_filing);
  const secondaryDebtor = caseDebtors.find(d => !d.is_primary && d.is_filing);
      if (primaryDebtor) {
        ab1Form.getTextField('Debtor 1').setText(
          [primaryDebtor.first_name, primaryDebtor.second_name, primaryDebtor.last_name]
            .filter(Boolean).join(' ')
        );
      }
      if (secondaryDebtor) {
        ab1Form.getTextField('Debtor 2').setText(
          [secondaryDebtor.first_name, secondaryDebtor.second_name, secondaryDebtor.last_name]
            .filter(Boolean).join(' ')
        );
      }
  ab1Form.getTextField('district').setText('Eastern District of Tennessee');
  ab1Form.getTextField('case_number').setText(caseData?.case_number || '');

  if (amended) ab1Form.getCheckBox('amended').check();

  if (realProperties.length>0)
  ab1Form.getCheckBox('real_estate_yes').check();
else  ab1Form.getCheckBox('real_estate_no').check();

  const [p1, p2] = realProperties;
  if (p1) fillRealPropertyFields(ab1Form, p1, 0,false,0);
  if (p2) fillRealPropertyFields(ab1Form, p2, 1,false,0);
  moveUncheckedCheckboxesToCorner(ab1Form, ab1Doc.getPages()[0].getSize(), ab1Doc.context);
  ab1Form.flatten();
  return ab1Doc;
}
async function generateAB3(ab3Bytes, caseData, realProperties, vehicles) {
  const ab3Doc = await PDFDocument.load(ab3Bytes);
  const ab3Form = ab3Doc.getForm();
  logFieldNames(ab3Form, 'AB-3');

  const caseDebtors = Array.isArray(caseData.debtors) ? caseData.debtors : [];
  const primaryDebtor = caseDebtors.find(d => d.is_primary && d.is_filing);
  if (primaryDebtor) {
    ab3Form.getTextField('Debtor 1').setText(
      [primaryDebtor.first_name, primaryDebtor.second_name, primaryDebtor.last_name]
        .filter(Boolean).join(' ')
    );
  }

  ab3Form.getTextField('Case number').setText(caseData?.case_number || '');

  // Last real property
  const lastProp = realProperties[realProperties.length - 1];
  if (lastProp && (realProperties.length % 3 === 0)) fillRealPropertyFields(ab3Form, lastProp, 0,true,realProperties.length - 1);

  // Total real estate value
  const realEstateTotal = realProperties.reduce((sum, p) => sum + (parseFloat(p.value_ownership_portion) || 0), 0);
  ab3Form.getTextField('real_estate_total_1').setText(String(realEstateTotal));

  // Vehicles section
  const nonRecVehicles = vehicles.filter(v => !v.is_recreational);
  if (nonRecVehicles.length > 0) ab3Form.getCheckBox('vehicles_yes').check();
  else ab3Form.getCheckBox('vehicles_no').check();

  // Fill up to 2 vehicle fields, using offset 0 for AB-3 (fields _1, _2)
  fillVehicleFields(ab3Form, nonRecVehicles.slice(0, 2), 0, false);
  moveUncheckedCheckboxesToCorner(ab3Form, ab3Doc.getPages()[0].getSize(), ab3Doc.context);
  ab3Form.flatten();
  return ab3Doc;
}

// Helper function: Generate one or more AB-4 continuation pages for vehicles 3+
/**
 * Generate AB-4 continuation pages for vehicles (groups of 6, starting from index 2).
 * @param {Array} vehicles - Array of vehicle objects (should be non-recreational, already sliced).
 * @param {string} debtor1Name - Name of primary debtor.
 * @param {string} caseNumber - Case number.
 * @param {number} startingOffset - The offset for vehicle numbering (e.g., 0 for first page, 6 for second, etc.).
 * @param {Uint8Array} templateBytes - The AB-4 template PDF bytes.
 * @returns {Promise<Array<PDFDocument>>} Array of filled AB-4 PDFDocument objects.
 */
async function generateAB4(vehicles, debtor1Name, caseNumber, startingOffset, templateBytes) {
  const ab4Docs = [];
  // vehicles: all non-recreational vehicles, already sliced to 3rd+ (i.e., index 2+)
  // startingOffset: 0 for first page (vehicle 3 = 3.3), 6 for second, etc.
  for (let i = 0; i < vehicles.length; i += 6) {
    const chunk = vehicles.slice(i, i + 6);
    const ab4Doc = await PDFDocument.load(templateBytes);
    const ab4Form = ab4Doc.getForm();
    // Fill debtor/case info
    if (debtor1Name) ab4Form.getTextField('Debtor 1').setText(debtor1Name);
    if (caseNumber) ab4Form.getTextField('case_number').setText(caseNumber);
    // Fill vehicle fields. Offset for this page: startingOffset + i
    // Vehicle numbers on AB-4 start at 3.3, so offset = (startingOffset + i)
    fillVehicleFields(ab4Form, chunk, startingOffset + i, true);
    moveUncheckedCheckboxesToCorner(ab4Form, ab4Doc.getPages()[0].getSize(), ab4Doc.context);
    ab4Form.flatten();
    ab4Docs.push(ab4Doc);
  }
  return ab4Docs;
}
// Utility: download a blob as a file
function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}

// Helper: fetch a PDF as Uint8Array
async function fetchPdf(url) {
  const res = await fetch(url);
  if (!res.ok) throw new Error('Failed to fetch PDF: ' + url);
  return new Uint8Array(await res.arrayBuffer());
}

export function formatScheduleCExemptionLaw(scope, code) {
  const law = String(code || '').trim();
  if (!law) return '';

  const normalizedScope = String(scope || '').toUpperCase();
  const alreadyHasTennesseePrefix =
    /(?:\b(?:TN|Tenn(?:essee)?)\.?\s+Code\s+Ann\.?|\bT\.?\s*C\.?\s*A\.?)/i.test(law);

  if (normalizedScope !== 'TN' || alreadyHasTennesseePrefix) return law;
  return `TN Code Ann. § ${law.replace(/^§+\s*/, '')}`;
}

/**
 * Fill and merge Schedule ABC forms (first 3 pages).
 * @param {Object} params - Data for filling the forms.
 * @returns {Promise<void>}
 */
export async function generateScheduleABC(params) {
  // Adjust these URLs as needed; ensure these files are in your public folder or accessible
  const ab1Url = '/forms/ab-1.pdf';
  const ab2Url = '/forms/ab-2.pdf';
  const ab3Url = '/forms/ab-3.pdf';
  const ab4Url = '/forms/ab-4.pdf';
  const ab5Url = '/forms/ab-5.pdf';
  const ab6Url = '/forms/ab-6.pdf';
  const ab7Url = '/forms/ab-7.pdf';
  const ab8Url = '/forms/ab-8.pdf';
  const c1Url = '/forms/c-1.pdf';
  const c2Url = '/forms/c-2.pdf';

  const [ab1Bytes, ab2Bytes, ab3Bytes, ab4Bytes, ab5Bytes, ab6Bytes, ab7Bytes, ab8Bytes, c1Bytes,c2Bytes] = await Promise.all([
    fetchPdf(ab1Url),
    fetchPdf(ab2Url),
    fetchPdf(ab3Url),
    fetchPdf(ab4Url),
    fetchPdf(ab5Url),
    fetchPdf(ab6Url),
    fetchPdf(ab7Url),
    fetchPdf(ab8Url),
    fetchPdf(c1Url),
    fetchPdf(c2Url)
  ]);
  const mergedPdf = await PDFDocument.create();
  const nonRecreationalVehicles = params.vehicles.filter(v => !v.is_recreational);
  const recreationalVehicles = params.vehicles.filter(v => v.is_recreational);
  if ((params.selectedSchedules.includes('AB') || params.selectedSchedules.includes('all'))){
  const ab1Doc = await generateAB1(ab1Bytes, params.caseData, params.realProperties,params.data.amended);
  const ab2Docs = [];

  const middleProps = params.realProperties.slice(2, -1);
  for (let i = 0; i < middleProps.length; i += 3) {
    const ab2Doc = await generateAB2(params.realProperties, ab2Bytes, params.caseData, i + 2);
    ab2Docs.push(ab2Doc);
  }

  
  for (const doc of [ab1Doc, ...ab2Docs]) {
    const [page] = await mergedPdf.copyPages(doc, [0]);
    mergedPdf.addPage(page);
  }

  // Generate AB-3 using the proper function and merge it
  const ab3Doc = await generateAB3(ab3Bytes, params.caseData, params.realProperties, params.vehicles);
  const [ab3Page] = await mergedPdf.copyPages(ab3Doc, [0]);
  mergedPdf.addPage(ab3Page);

  // Add AB-4 continuation pages for vehicles 3+ (groups of 6)
  
  const remainingVehicles = nonRecreationalVehicles.slice(2); // Start after first 2 used in AB-3
  let ab4Docs = [];
  if (remainingVehicles.length > 0) {
    // Get debtor 1 name and case number
    const caseDebtors = Array.isArray(params.caseData.debtors) ? params.caseData.debtors : [];
    const primaryDebtor = caseDebtors.find(d => d.is_primary && d.is_filing);
    const debtor1Name = primaryDebtor
      ? [primaryDebtor.first_name, primaryDebtor.second_name, primaryDebtor.last_name].filter(Boolean).join(' ')
      : '';
    const caseNumber = params.caseData.caseNumber || params.caseData.case_number || '';
    ab4Docs = await generateAB4(
      remainingVehicles,
      debtor1Name,
      caseNumber,
      0, // startingOffset: 0 for first AB-4 continuation page (vehicle 3 = 3.3)
      ab4Bytes
    );
    // Merge each AB-4 page
    for (const ab4Doc of ab4Docs) {
      const [ab4Page] = await mergedPdf.copyPages(ab4Doc, [0]);
      mergedPdf.addPage(ab4Page);
    }
  }

  // --- AB-5: Recreational Vehicles ---
  // Calculate total vehicle value
  const vehicleTotal =
    calculateTotalVehicleValue(params.vehicles) +
    calculateTotalVehicleValue(params.recreationalVehicles);
  // Prepare data for AB-5
  
  const ab5Data = {
    debtor1: {
      fullName: (() => {
        const caseDebtors = Array.isArray(params.caseData.debtors) ? params.caseData.debtors : [];
        const primaryDebtor = caseDebtors.find(d => d.is_primary && d.is_filing);
        return primaryDebtor
          ? [primaryDebtor.first_name, primaryDebtor.second_name, primaryDebtor.last_name].filter(Boolean).join(' ')
          : '';
      })(),
    },
    caseNumber: params.caseData.caseNumber || params.caseData.case_number || '',
    recreationalVehicles: recreationalVehicles || [],
  };
  const ab5 = await generateAB5(ab5Data, vehicleTotal, ab5Bytes);
  const [ab5Page] = await mergedPdf.copyPages(ab5, [0]);
  mergedPdf.addPage(ab5Page);

  // --- AB-6: Recreational Vehicles continuation pages ---
  // If more than 4 recreational vehicles, generate AB-6 continuation pages
  if (recreationalVehicles.length > 4) {
    // Get debtor 1 name and case number
    const caseDebtors = Array.isArray(params.caseData.debtors) ? params.caseData.debtors : [];
    const primaryDebtor = caseDebtors.find(d => d.is_primary && d.is_filing);
    const clientName = primaryDebtor
      ? [primaryDebtor.first_name, primaryDebtor.second_name, primaryDebtor.last_name].filter(Boolean).join(' ')
      : '';
    const caseNumber = params.caseData.caseNumber || params.caseData.case_number || '';
    // Generate AB-6 continuation pages for recreational vehicles starting from the 5th
    const ab6Docs = await generateAB6(recreationalVehicles, clientName, params.caseData.caseNumber, 0);
    for (const doc of ab6Docs) {
      const [page] = await mergedPdf.copyPages(doc, [0]);
      mergedPdf.addPage(page);
    }
  }
// --- AB-7: Household Goods & Personal Property ---
  // Compose the correct data for generateAB7
  // Use householdItems from params if available, otherwise caseData.householdGoods
  const ab7Data = {
    debtorName: (() => {
      const caseDebtors = Array.isArray(params.caseData.debtors) ? params.caseData.debtors : [];
      const primaryDebtor = caseDebtors.find(d => d.is_primary && d.is_filing);
      return primaryDebtor
        ? [primaryDebtor.first_name, primaryDebtor.second_name, primaryDebtor.last_name].filter(Boolean).join(' ')
        : '';
    })(),
    caseNumber: params.caseData.caseNumber || params.caseData.case_number || '',
    householdGoods: params.householdItems || params.caseData.householdGoods || [],
  };
  const ab7Doc = await generateAB7(ab7Data, ab7Bytes);
  const [ab7Page] = await mergedPdf.copyPages(ab7Doc, [0]);
  mergedPdf.addPage(ab7Page);

  const ab8Doc = await generateAB8(params.realProperties, params.vehicles, params.householdItems, params.financialAssets, params.businessAssets, params.farmAssets, params.otherProperties, ab8Bytes,params.caseData);
  // Instead of just the first page, add all AB-8 template pages
  for (let i = 0; i < ab8Doc.getPageCount(); i++) {
    const [page] = await mergedPdf.copyPages(ab8Doc, [i]);
    mergedPdf.addPage(page);
  }
  console.log(params.scope)

  const pages = mergedPdf.getPages();
  const totalPages = pages.length;
  const helveticaFont = await mergedPdf.embedFont(StandardFonts.Helvetica);
  pages.forEach((page, index) => {
    const { width, height } = page.getSize();
    const text = `page ${index + 1} of ${totalPages}`;
    page.drawText(text, {
      x: width - 100, // adjust based on layout
      y: 15,          // bottom margin
      size: 8,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });
  });
  // Load AB-5 and AB-6 forms and log field names
  // Optionally: AB-6 and field logging (keep as is)
  const formc1Doc = await PDFDocument.load(c1Bytes);
  const formc1 = formc1Doc.getForm();
  logFieldNames(formc1, 'c1');
}
if ((params.selectedSchedules.includes('C') || params.selectedSchedules.includes('all'))){
  // BELOW THIS LINE WE WILL START BUILDING THE SCHEDULE C INFORMATION
  const exemptionItems = [];

  (params.realProperties || []).forEach((item, idx) => {
    exemptionItems.push({
      description: item.street1,
      line: `1.${idx + 1}`,
      value: item.value_ownership_portion,
      exemption_amount: item.exemption_amount,
      exemption_code: item.exemption_code,
    });
  });

  // 2. Non-Recreational Vehicles
  (nonRecreationalVehicles || []).forEach((item, idx) => {
    exemptionItems.push({
      description: `${item.year} ${item.make} ${item.model}`,
      line: `3.${idx + 1}`,
      value: item.value_ownership_portion,
      exemption_amount: item.exemption_amount,
      exemption_code: item.exemption_code,
    });
  });

  // 3. Recreational Vehicles
  (recreationalVehicles || []).forEach((item, idx) => {
    exemptionItems.push({
      description: `${item.year} ${item.make} ${item.model}`,
      line: `4.${idx + 1}`,
      value: item.value_ownership_portion,
      exemption_amount: item.exemption_amount,
      exemption_code: item.exemption_code,
    });
  });

  // 4. Household Goods (category-dependent lines)
  const householdTypeToLine = {
    furnishings: 6,
    electronics: 7,
    collectibles: 8,
    sports: 9,
    firearms: 10,
    clothes: 11,
    jewelry: 12,
    non_farm_animals: 13,
    other: 14,
  };
  console.log(params.householdItems);
  (params.householdItems || []).forEach(item => {
    // use item.category to look up the line number
    const line = householdTypeToLine[item.category];
    if (!line) return;
    exemptionItems.push({
      description: item.description,
      line: String(line),
      // use item.value (not amount)
      value: item.value,
      exemption_amount: item.exemption_amount,
      exemption_code: item.exemption_code,
    });
  });
  console.log(exemptionItems);

  // 5. Financial Assets
  Object.entries(params.financialAssets || {}).forEach(([category, assetList]) => {
  assetList.forEach(item => {
    exemptionItems.push({
      description: item.description ||
                   item.entity ||
                   item.institution_name ||
                   item.issuer ||
                   item.company ||
                   item.account_type ||
                   item.obligation_type ||
                   category.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),  // <-- category is safely used here
      line: String(item.form_number),
      value: item.amount,
      exemption_amount: item.exemption_amount,
      exemption_code: item.exemption_code,
    });
  });
});

  // 6. Business Assets
  Object.values(params.businessAssets || {}).forEach(assetList => {
    assetList.forEach(item => {
      exemptionItems.push({
        description: item.description,
        line: String(item.form_number),
        value: item.amount,
        exemption_amount: item.exemption_amount,
        exemption_code: item.exemption_code,
      });
    });
  });

  // 7. Farm Assets
  Object.values(params.farmAssets || {}).forEach(assetList => {
    assetList.forEach(item => {
      exemptionItems.push({
        description: item.description,
        line: String(item.FORM_NUMBER),
        value: item.amount,
        exemption_amount: item.exemption_amount,
        exemption_code: item.exemption_code,
      });
    });
  });

  // 8. Other Properties
  (params.otherProperties || []).forEach(item => {
    exemptionItems.push({
      description: item.description,
      line: String(item.form_number),
      value: item.amount,
      exemption_amount: item.exemption_amount,
      exemption_code: item.exemption_code,
    });
  });
  console.log(params.realProperties)
  console.log(exemptionItems)

const homesteadTotal = (params.realProperties || []).reduce((sum, item) => {
  return sum + (item.exemption_amount || 0);
}, 0);

 const c1Doc = await generateC1(homesteadTotal, exemptionItems, params.caseData, c1Bytes,params.scope,params.data.amended);
  const [c1Page] = await mergedPdf.copyPages(c1Doc, [0]);
  mergedPdf.addPage(c1Page);

  const c2Doc = await PDFDocument.create();
  await generateC2(exemptionItems, params.caseData, c2Bytes, c2Doc, params.scope);

  for (let i = 0; i < c2Doc.getPageCount(); i++) {
    const [page] = await mergedPdf.copyPages(c2Doc, [i]);
    mergedPdf.addPage(page);
  }
}
  let decPdfDoc = null
  let amendedPdfDoc = null;
      if (params.data.amended){
        // Use today's date for any Executed on / signature date fields when amended
        const _now = new Date();
        const _yyyy = _now.getFullYear();
        const _mm = String(_now.getMonth() + 1).padStart(2, '0');
        const _dd = String(_now.getDate()).padStart(2, '0');
        const _todayISO = `${_yyyy}-${_mm}-${_dd}`;

          const decUrl = '/forms/dec.pdf'
          const decExistingPdfBytes = await fetch(decUrl).then(res => res.arrayBuffer());
          decPdfDoc = await PDFDocument.load(decExistingPdfBytes);
          const decForm = decPdfDoc.getForm();

          (params.data.caseInfo.debtors.filter(d => d.is_filing) || []).forEach((debtor, index) => {
              const amendPrefix = debtor.is_primary ? 'Debtor 1' : 'Debtor 2';
              decForm.getTextField(`${amendPrefix}`).setText(`${(debtor.first_name || '')} ${(debtor.second_name || '')} ${(debtor.last_name || '')} ${(debtor.suffix || '')}`);
          });

          (params.data.caseInfo.debtors.filter(d => d.is_filing) || []).forEach((debtor, index) => {
              const amendPrefix = debtor.is_primary ? 'Debtor1' : 'Debtor2';
              decForm.getTextField(`${amendPrefix}.signature`).setText(`s/ ${(debtor.first_name || '')} ${(debtor.second_name || '')} ${(debtor.last_name || '')} ${(debtor.suffix || '')}`);
              decForm.getTextField(`${amendPrefix}.Executed on`).setText(fmtDate(_todayISO));
          });

          decForm.getCheckBox(`no_preparer`).check();
          decForm.getCheckBox(`amended`).check();
          decForm.getTextField('case_number').setText(params.data.caseInfo.case_number || '');
          decForm.getTextField('district').setText("Eastern District of Tennessee");
          const page1 = decPdfDoc.getPage(0);
          const width1 = page1.getWidth();
          const height1 = page1.getHeight();
          decForm.getFields().forEach(field => {
              if (field instanceof PDFCheckBox && !field.isChecked()) {
                field.acroField.getWidgets().forEach(widget => {
                  const dict = widget.acroAnnotation?.dict || widget.dict;
                  // move widget off-page by setting its Rect to a small area beyond the page bounds
                  dict.set(
                    PDFName.of('Rect'),
                    decPdfDoc.context.obj([
                      width1 + 5,   // lower-left x just outside page
                      height1 + 5,  // lower-left y just outside page
                      width1 + 15,  // upper-right x a bit further out
                      height1 + 15  // upper-right y a bit further out
                    ])
                  );
                });
              }
            });

          const helvetica = await decPdfDoc.embedFont(StandardFonts.Helvetica);
          decForm.updateFieldAppearances(helvetica);
          decForm.flatten();

          const amendedUrl = '/forms/notice-of-amendment.pdf'
          const amendedExistingPdfBytes = await fetch(amendedUrl).then(res => res.arrayBuffer());
          amendedPdfDoc = await PDFDocument.load(amendedExistingPdfBytes);
          const amendedForm = amendedPdfDoc.getForm();
  
          (params.data.caseInfo.debtors || []).forEach((debtor, index) => {
              const amendPrefix = debtor.is_primary ? 'debtor1' : 'debtor2';
              amendedForm.getTextField(`${amendPrefix}`).setText(`${(debtor.first_name || '')} ${(debtor.second_name || '')} ${(debtor.last_name || '')} ${(debtor.suffix || '')}`);
          });
          amendedForm.getTextField('case_number').setText(params.data.caseInfo.case_number || '');
          amendedForm.getTextField('chapter').setText(params.data.caseInfo.chapter || '');
          amendedForm.getTextField('date').setText(fmtLongDate(_todayISO));
          // dynamically build amended files list excluding SOI, Matrix, and 'all'
          // determine which schedules to list when building amended labels
          const scheduleTypes = params.selectedSchedules.includes('all')
            ? ['AB', 'C']
            : params.selectedSchedules.filter(type => !['SOI', 'Matrix', 'all'].includes(type));
          const scheduleLabels = scheduleTypes
            .map(type => `Schedule ${type}`)
            .join(', ');
          amendedForm.getTextField('amended_files').setText(`${scheduleLabels}`);
          amendedForm.getTextField('items_served').setText(`Amended ${scheduleLabels}, Declaration, and Notice of Amendment`);
          amendedForm.getTextField('reason_amended').setText(params.data.amendedReason);
          amendedForm.getTextField('creditors_served_description').setText(
            amendmentServiceDescription(params.data),
          );

          amendedForm.updateFieldAppearances(helvetica);
          amendedForm.flatten();
          
      }
          if (params.data.amended && amendedPdfDoc) {
        // then amended form
        const decPages = await mergedPdf.copyPages(decPdfDoc, decPdfDoc.getPageIndices());
        decPages.forEach(p => mergedPdf.addPage(p));
        const amendedPages = await mergedPdf.copyPages(amendedPdfDoc, amendedPdfDoc.getPageIndices());
        amendedPages.forEach(p => mergedPdf.addPage(p));
        // then creditor list
        await appendAmendmentServiceList(mergedPdf, params.data, generateCreditorsListPdf);
        const envelopes = await generateEnvelopesPdf(amendmentServiceRecipients(params.data));
      }

    if (params.selectedSchedules.includes('AB') || params.selectedSchedules.includes('C') || params.selectedSchedules.includes('all')){
  const mergedBytes = await mergedPdf.save();
   const blob = new Blob([mergedBytes], { type: 'application/pdf' });
    const formData2 = new FormData();
    formData2.append('file', blob, 'draft.pdf');
    const caseDebtors = Array.isArray(params.caseData.debtors) ? params.caseData.debtors : [];
    const primaryDebtor = caseDebtors.find(d => d.is_primary && d.is_filing);
    const primaryName = [primaryDebtor.first_name, primaryDebtor.second_name, primaryDebtor.last_name]
      .filter(Boolean).join(' ');

      const response = await fetch(`${API_URL2}/optimize-pdf/`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData2,
        credentials: 'include',
      });

      let finalBlob;
      if (response.ok) {
        finalBlob = await response.blob();
      } else {
        console.error("Optimization failed");
        finalBlob = blob;  // fallback to original merged blob
      }

      // Optional: trigger download here
      //const link = document.createElement('a');
      //link.href = URL.createObjectURL(finalBlob);
      //link.download = response.ok ? `${primaryName}_ScheduleAB.pdf` : `${primaryName}_ScheduleAB-failed.pdf`;
      //link.click();

      return finalBlob;
      }
}
async function generateC2(exemptionItems, caseData, c2Bytes, c2Doc, scope) {
  const itemsPerPage = 12;
  const continuationItems = exemptionItems.slice(3); // Skip first 3
  const caseDebtors = Array.isArray(caseData.debtors) ? caseData.debtors : [];
  const primaryDebtor = caseDebtors.find(d => d.is_primary && d.is_filing);
  const totalPages = 1 + Math.ceil((exemptionItems.length - 3) / 12)
  
    
  for (let pageIndex = 0; pageIndex < Math.ceil(continuationItems.length / itemsPerPage); pageIndex++) {
    const pageItems = continuationItems.slice(
      pageIndex * itemsPerPage,
      (pageIndex + 1) * itemsPerPage
    );

    // Create a fresh doc from the template
    const pageDoc = await PDFDocument.load(c2Bytes);
    const form = pageDoc.getForm();
    form.getTextField("page 2").setText((pageIndex + 2).toString() || "");
    form.getTextField("page").setText(totalPages.toString() || "");
    if (primaryDebtor) {
              form.getTextField('Debtor 1').setText(
                [primaryDebtor.first_name, primaryDebtor.second_name, primaryDebtor.last_name]
                  .filter(Boolean).join(' ')
              );
            }
            form.getTextField('case_number').setText(caseData?.case_number || '');
    pageItems.forEach((item, index) => {
      const fieldIndex = index + 1;


       
      form.getTextField(`description_${fieldIndex}`).setText(item.description || "");
      form.getTextField(`value_${fieldIndex}`).setText(
        item.value !== undefined && item.value !== null ? item.value.toString() : ""
      );
      form.getTextField(`exemption_amount_${fieldIndex}`).setText(
        item.exemption_amount !== undefined && item.exemption_amount !== null
          ? item.exemption_amount.toString()
          : ""
      );
      form.getTextField(`exemption_law_${fieldIndex}`).setText(
        formatScheduleCExemptionLaw(scope, item.exemption_code)
      );
      form.getTextField(`line_${fieldIndex}`).setText(item.line || "");
      form.getCheckBox(`exemption_${fieldIndex}`).check();
    });

    // Move checkboxes off the page just in case
    moveUncheckedCheckboxesToCorner(form, pageDoc.getPages()[0].getSize(), pageDoc.context);

    // Flatten this page before merging
    form.flatten();

    // Copy flattened page into c2Doc
    const [copiedPage] = await c2Doc.copyPages(pageDoc, [0]);
    c2Doc.addPage(copiedPage);
  }

  return c2Doc;
}


async function generateC1(homesteadTotal,exemptionItems,caseData,c1Bytes,scope,amended)
{
  const c1Doc = await PDFDocument.load(c1Bytes);
  const c1Form = c1Doc.getForm();

  console.log(caseData)
  const caseDebtors = Array.isArray(caseData.debtors) ? caseData.debtors : [];
  const primaryDebtor = caseDebtors.find(d => d.is_primary && d.is_filing);
  const secondaryDebtor = caseDebtors.find(d => !d.is_primary && d.is_filing);
      if (primaryDebtor) {
        c1Form.getTextField('Debtor 1').setText(
          [primaryDebtor.first_name, primaryDebtor.second_name, primaryDebtor.last_name]
            .filter(Boolean).join(' ')
        );
      }
      if (secondaryDebtor) {
        c1Form.getTextField('Debtor 2').setText(
          [secondaryDebtor.first_name, secondaryDebtor.second_name, secondaryDebtor.last_name]
            .filter(Boolean).join(' ')
        );
      }
  if (amended)
    c1Form.getCheckBox('amended').check()
  c1Form.getTextField('district').setText('Eastern District of Tennessee');
  c1Form.getTextField('case_number').setText(caseData?.case_number || '');

  if (String(scope || '').toLowerCase() === 'federal'){
    c1Form.getCheckBox('federal_exemptions').check()
  }
  else {
    c1Form.getCheckBox('state_exemptions').check()
  }

  if (homesteadTotal > 214000) {
     c1Form.getCheckBox('big_homestead_yes').check()
     c1Form.getCheckBox('recent_acquire_no').check()
  } else {
    c1Form.getCheckBox('big_homestead_no').check()
  }
  const firstThree = exemptionItems.slice(0, 3);

  const c1Fields = {
    description_1: firstThree[0]?.description || "",
    value_1: firstThree[0]?.value || "", // or use a fallback like "0"
    exemption_amount_1: firstThree[0]?.exemption_amount ?? "",
    exemption_law_1: firstThree[0]?.exemption_code || "",
    line_1: firstThree[0]?.line || "",

    description_2: firstThree[1]?.description || "",
    value_2: firstThree[1]?.value || "",
    exemption_amount_2: firstThree[1]?.exemption_amount ?? "",
    exemption_law_2: firstThree[1]?.exemption_code || "",
    line_2: firstThree[1]?.line || "",

    description_3: firstThree[2]?.description || "",
    value_3: firstThree[2]?.value || "",
    exemption_amount_3: firstThree[2]?.exemption_amount ?? "",
    exemption_law_3: firstThree[2]?.exemption_code || "",
    line_3: firstThree[2]?.line || "",
  };

  c1Form.getTextField("description_1").setText(firstThree[0]?.description || "");
  c1Form.getTextField("value_1").setText(firstThree[0]?.value?.toString() || "");
  c1Form.getTextField("exemption_amount_1").setText(firstThree[0]?.exemption_amount?.toString() || "");
  c1Form.getTextField("exemption_law_1").setText(
    formatScheduleCExemptionLaw(scope, firstThree[0]?.exemption_code)
  );
  
  c1Form.getTextField("line_1").setText(firstThree[0]?.line || "");
  c1Form.getCheckBox("exemption_1").check()

  c1Form.getTextField("description_2").setText(firstThree[1]?.description || "");
  c1Form.getTextField("value_2").setText(firstThree[1]?.value?.toString() || "");
  c1Form.getTextField("exemption_amount_2").setText(firstThree[1]?.exemption_amount?.toString() || "");
  c1Form.getTextField("exemption_law_2").setText(
    formatScheduleCExemptionLaw(scope, firstThree[1]?.exemption_code)
  );
  c1Form.getTextField("line_2").setText(firstThree[1]?.line || "");
  c1Form.getCheckBox("exemption_2").check()

  c1Form.getTextField("description_3").setText(firstThree[2]?.description || "");
  c1Form.getTextField("value_3").setText(firstThree[2]?.value?.toString() || "");
  c1Form.getTextField("exemption_amount_3").setText(firstThree[2]?.exemption_amount?.toString() || "");
  c1Form.getTextField("exemption_law_3").setText(
    formatScheduleCExemptionLaw(scope, firstThree[2]?.exemption_code)
  );
  c1Form.getTextField("line_3").setText(firstThree[2]?.line || "");
  c1Form.getCheckBox("exemption_3").check()


  const totalPages = 1 + Math.ceil((exemptionItems.length - 3) / 12)
  c1Form.getTextField("page_total").setText(totalPages.toString() || "");
      moveUncheckedCheckboxesToCorner(c1Form, c1Doc.getPages()[0].getSize(), c1Doc.context);
    c1Form.flatten();
    return c1Doc
}

// Generate AB-6 PDF for recreational vehicle continuation pages (groups of 6)
/**
 * Generate AB-6 continuation pages for recreational vehicles (groups of 6).
 * @param {PDFDocument} doc - The template PDFDocument (should be loaded from AB-6 bytes).
 * @param {PDFForm} form - The PDFForm for the template.
 * @param {Object} caseData - Object with .full_name and .case_number.
 * @param {Array} vehicles - Array of recreational vehicle objects.
 * @param {number} pageOffset - Optional offset for vehicle numbering.
 * @returns {Promise<Array>} Array of filled AB-6 pages.
 */
async function generateAB6(recreationalVehicles, debtor1Name, caseNumber, pageOffset = 0) {
  const docs = [];
  const chunks = [];

  const continuationVehicles = recreationalVehicles.slice(4); // Skip first 4 (AB-5)
  const vehiclesPerPage = 6;

  for (let i = 0; i < continuationVehicles.length; i += vehiclesPerPage) {
    chunks.push(continuationVehicles.slice(i, i + vehiclesPerPage));
  }

  for (let index = 0; index < chunks.length; index++) {
    const vehicleChunk = chunks[index];
    const templateBytes = await fetch("/forms/ab-6.pdf").then(res => res.arrayBuffer());
    const doc = await PDFDocument.load(templateBytes);
    const form = doc.getForm();
    const page = doc.getPages()[0];

    const counterStart = 5 + (index * vehiclesPerPage);
    const fieldPrefix = "vehicle_"
    vehicleChunk.forEach((vehicle, i) => {
      const fieldIndex = i + 1;
      const counter = (counterStart + i);
      form.getTextField(`${fieldPrefix}${fieldIndex}`).setText(`4.${counter}` || '');
      form.getTextField(`${fieldPrefix}year_${fieldIndex}`).setText(vehicle.year?.toString() || '');
      form.getTextField(`${fieldPrefix}make_${fieldIndex}`).setText(vehicle.make || '');
      form.getTextField(`${fieldPrefix}model_${fieldIndex}`).setText(vehicle.model || '');
      form.getTextField(`${fieldPrefix}value_total_${fieldIndex}`).setText(vehicle.value_total?.toString() || '');
      form.getTextField(`${fieldPrefix}value_ownership_${fieldIndex}`).setText(vehicle.value_ownership_portion?.toString() || '');
      form.getTextField(`${fieldPrefix}other_information_${fieldIndex}`).setText(vehicle.other_info || '');

      // Debtor checkboxes
      const ownership = vehicle.ownership;
      if (ownership === 'debtor1') {
        form.getCheckBox(`${fieldPrefix}debtor1_owes_${fieldIndex}`).check();
      } else if (ownership === 'debtor2') {
        form.getCheckBox(`${fieldPrefix}debtor2_owes_${fieldIndex}`).check();
      } else if (ownership === 'd1_d2') {
        form.getCheckBox(`${fieldPrefix}joint_owes_${fieldIndex}`).check();
      } else if (ownership === 'joint_third') {
        form.getCheckBox(`${fieldPrefix}third_owes_${fieldIndex}`).check();
      }

      // Community property checkbox
      if (vehicle.community_property) {
        form.getCheckBox(`${fieldPrefix}community_${fieldIndex}`).check();
      }

      // handle checkboxes here as needed...
    });

    form.getTextField("Debtor 1").setText(debtor1Name || "");
    form.getTextField("case_number").setText(caseNumber || "");
    form.getTextField("page_count").setText((pageOffset + index + 1).toString());
    form.getTextField("page_total").setText((pageOffset + chunks.length).toString());

    moveUncheckedCheckboxesToCorner(form, doc.getPages()[0].getSize(), doc.context);
    form.flatten();
    docs.push(doc);
  }

  return docs;
}
